import { createSlice } from "@reduxjs/toolkit";
import { DashboardApi } from "../../../Service/dashboard";
import { GetcustomerList } from "../../async-actions/digitalmarketing/dashboard";

const initialState = {
  customerList: [],
  healthIssues:[],
  status:[],
  customerJourney:[],
  remindedFor:[],
  remindedTo:[]
};

const customerSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(GetcustomerList.fulfilled.match,(state, action) => {
      state.customerList = action.payload.data.data;      
    })
    .addMatcher(DashboardApi.endpoints.getDashboardCustomers.matchFulfilled,(state, action) => {
      state.customerList = action.payload;      
    })
    .addMatcher(DashboardApi.endpoints.getDashboardHealthIssuess.matchFulfilled, (state, action) => {
      // pretend this field and this payload data exist for sake of example
      state.healthIssues = action.payload["data"]
    })
    .addMatcher(DashboardApi.endpoints.getDashboardStatuses.matchFulfilled, (state, action) => {
      // pretend this field and this payload data exist for sake of example
      state.status = action.payload["data"]
    })
    .addMatcher(DashboardApi.endpoints.getDashboardCustomerJourneyTypes.matchFulfilled, (state, action) => {
      // pretend this field and this payload data exist for sake of example
      state.customerJourney = action.payload["data"]
    })
    .addMatcher(DashboardApi.endpoints.getDashboardRemindedFor.matchFulfilled, (state, action) => {
      // pretend this field and this payload data exist for sake of example
      state.remindedFor = action.payload["data"]
    })
    .addMatcher(DashboardApi.endpoints.getDashboardRemindedTo.matchFulfilled, (state, action) => {
      // pretend this field and this payload data exist for sake of example
      state.remindedTo = action.payload["data"]
    })
    
  },
});
export default customerSlice.reducer;
